import { EquipmentDTO, RailResponseDTO } from "./response.types";
import { RailMessagesDTO } from "entities/shared/railCard.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { ShipmentCardMetadataDTO } from "entities/shared/subscriptionModel";
import { ValueOf } from "shared/lib/typeCheck.lib";

export class SearchApiParser {
  private model: RailResponseDTO;
  public readonly requestLimitReached: boolean = false;
  public readonly isSuccess: boolean = false;

  constructor(model: RailResponseDTO) {
    this.model = model;
    this.requestLimitReached = this.model.status_code === RailMessagesDTO.API_KEY_LIMIT_REACHED;
    this.isSuccess = this.model.status_code === RailMessagesDTO.OK;
  }

  get metadata(): ShipmentCardMetadataDTO {
    return this.model.metadata;
  }

  get responseStatus(): ValueOf<typeof RailMessagesDTO> {
    return this.model.status_code;
  }

  get number(): SearchReferenceDTO {
    return this.model.metadata.request_parameters.number;
  }

  get equipments(): EquipmentDTO[] {
    return this.model.data.equipments ?? [];
  }

  get carrierCode(): string {
    return this.model.metadata.request_parameters.carrier_code;
  }
}
